export const supportUrl = 'https://community.activepieces.com'